/**
 * "Buy Now" buttons on Pro product cards.
 * Adds the variant with Shopify's AJAX cart API and announces it with the same
 * CartLinesUpdateEvent Horizon's product form uses, so the cart icon count and
 * the cart drawer update (and the drawer opens if the theme is set to do so).
 */
import { CartLinesUpdateEvent } from '@shopify/events';

if (!window.__productCardProReady) {
  window.__productCardProReady = true;

  const cartAddUrl = () => (window.Theme?.routes?.cart_add_url || '/cart/add') ;
  const cartUrl = () => (window.Theme?.routes?.cart_url || '/cart');

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-pcp-add]');
    if (!button) return;
    event.preventDefault();
    if (button.getAttribute('aria-busy') === 'true') return;

    const label = button.querySelector('.pcp__button-label');
    const originalText = label?.textContent;
    button.setAttribute('aria-busy', 'true');

    const formData = new FormData();
    formData.append('id', button.dataset.variantId);
    formData.append('quantity', '1');

    const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);
    if (sectionIds.length) formData.append('sections', sectionIds.join(','));

    const deferred = CartLinesUpdateEvent.createPromise();
    button.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: button.dataset.variantId, quantity: 1 }],
        promise: deferred.promise,
      })
    );

    try {
      const response = await fetch(cartAddUrl(), {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: formData,
      }).then((r) => r.json());

      const ajaxCart = await fetch(`${cartUrl()}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());

      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
        detail: {
          items: ajaxCart.items,
          source: 'product-card-pro',
          itemCount: 1,
          sections: response.sections,
          didError: Boolean(response.status),
        },
      });

      if (response.status) {
        if (label) label.textContent = response.description || response.message || 'Error';
      } else if (button.dataset.checkout === 'true') {
        window.location.href = '/checkout';
        return;
      } else if (label) {
        label.textContent = button.dataset.addedLabel || 'Added!';
      }
    } catch (error) {
      deferred.reject(error);
      if (label) label.textContent = 'Error';
    }

    setTimeout(() => {
      if (label && originalText) label.textContent = originalText;
      button.removeAttribute('aria-busy');
    }, 1800);
  });
}
